<template>
  <v-card color="#F2C953">
    <v-card-title>Start a 90 Day Free Trial</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="background-color: #FFD457; padding: 8px 8px 8px 24px;">
      Try the fully-featured Parish Online and keep your data if you carry on with a full subscription.
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text style="background-color: #FFD457; padding: 8px 8px 8px 24px;">
      Once your trial has ended you have the option to switch to a full subscription or even take advantage of a
      BHIB-funded subscription.
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters justify="end">
        <v-btn rounded outlined
               color="black"
               @click="handleSelect()"
        >
          <span class="pr-1">Select</span>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "TrialCard",
    components: {},
    props: {},
    data() {
      return {}
    },
    computed: {},
    methods: {
      handleSelect() {
        this.$emit('select');
      }
    }
  }
</script>
